import api from './api';

const adminService = {
  getDashboard: () => api.get('/admin/dashboard'),
  
  // Users
  getUsers: (params) => api.get('/admin/users', { params }),
  updateUserStatus: (userId, isActive) => api.patch(`/admin/users/${userId}/status`, { isActive }),
  deleteUser: (userId) => api.delete(`/admin/users/${userId}`),
  
  // Vendors
  getVendors: (params) => api.get('/admin/vendors', { params }),
  updateVendorKYC: (vendorId, status, rejectionReason) =>
    api.patch(`/admin/vendors/${vendorId}/kyc`, { status, rejectionReason }),
  updateVendorStatus: (vendorId, isActive) => api.patch(`/admin/vendors/${vendorId}/status`, { isActive }),
  deleteVendor: (vendorId) => api.delete(`/admin/vendors/${vendorId}`),
  
  // Machines
  getMachines: (params) => api.get('/admin/machines', { params }),
  updateMachineStatus: (machineId, status, rejectionReason) =>
    api.patch(`/admin/machines/${machineId}/status`, { status, rejectionReason }),
  deleteMachine: (machineId) => api.delete(`/admin/machines/${machineId}`),
  
  // Categories
  getCategories: () => api.get('/categories'),
  updateCategory: (categoryId, data) => api.patch(`/admin/categories/${categoryId}`, data),
  toggleCategory: (categoryId, isActive) => api.patch(`/admin/categories/${categoryId}/toggle`, { isActive }),
  
  // Bookings
  getBookings: (params) => api.get('/admin/bookings', { params }),
  processRefund: (bookingId, amount, reason) =>
    api.post(`/admin/bookings/${bookingId}/refund`, { amount, reason }),
    
  getReports: (params) => api.get('/admin/reports', { params }),
};

export default adminService;
